import SubtradeChannel from './SubtradeChannel'
import TradeName from './TradeName'
import KeyAccount from './KeyAccount'
import TradeGroup from './TradeGroup'
import CommissionPaymentFrequency from './CommissionPaymentFrequency'
import CustomerOwnership from './CustomerOwnership'
import FullServicePricingType from './FullServicePricingType'
export class PricingInfo {
    RequestID: number;
    SubtradeChannelID?: number;
    SubtradeChannel?: SubtradeChannel;
    TradeNameID?: number;
    TradeName?: TradeName;
    KeyAccountID?: number;
    KeyAccount?: KeyAccount;
    TradeGroupID?: number;
    TradeGroup?: TradeGroup;
    CommissionPaymentFrequencyID?: number;
    CommissionPaymentFrequency?: CommissionPaymentFrequency;
    PrimaryFranchiseGroup: string;
    SecondaryFranchiseAgreementsGroup: string;
    OverarchingProgramsGroup: string;
    CommissionPayerNumber: string;
    CreatePayerNumber?: boolean;
    FullServicePricingTypeID?: number;
    FullServicePricingType?: FullServicePricingType;
    CustomerOwnershipID?: number;
    CustomerOwnership?: CustomerOwnership;
    NewContractCustomer: boolean;
    CRTNumber: string;
    PrimaryGroupCustomerNumbers: string;
    NewPrimaryGroupName: string;
}

export default PricingInfo;